import { Box } from "@mui/material";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import useBreakpoint from "./useBreakpoint";

const MyAccount = () => {
    const [data, setData] = useState({});
    const [size] = useBreakpoint();

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        axios.get("http://ascola-dev01.it.auth.gr/api/users", {
                params: {
                    email: tokenEmail(token)
                }, headers: { Authorization: "Bearer " + token} })
            .then((response) => {
            console.log(response); setData(response.data);
            });
        }, []);

    

        const handleChange = (e) => {
            const values = {...data};
            
            if (e.target.type === "radio") {
                values[e.target.id.substring(0, e.target.id.indexOf("-"))] = e.target.value;
            }
            setData(values);
        }

        const handleSubmit = () => {
            delete data.created_at;
            delete data.updated_at;
            delete data.user_id;
            delete data.email;
            const token = localStorage.getItem('access_token');

            console.log(data);
            axios.patch("http://ascola-dev01.it.auth.gr/api/users", data,{
                params: {
                    email: tokenEmail(token)
                }, headers: { Authorization: "Bearer " + localStorage.getItem('access_token')}}
                // {user: data}
                // ,{ headers: { Authorization: "Bearer " + localStorage.getItem('access_token')}})
            )
              .then((response) => {
                console.log(response); alert("Successfully Submitted!")
              });

        }
        const tokenEmail = (token) => {
            if (!token) return true;
            try {
                const decodedToken = jwtDecode(token);
                return decodedToken.email;
            } catch (error) {
                console.error('Error decoding token:', error);
                return true;
            }
            };
    
    return (
      <>
        <div className="my-account-main-container rounded-3 mx-auto d-flex flex-column position-relative" style={(size === "xs" || size === "sm" || size === "md") ? {width: "90%"} : {width: "35%"}}>
        <div className="title mb-4">
            <h1 className="register-text" style={{fontSize: 40, marginBottom: 25}}>My account</h1>
            <Form.Group className="mb-3" controlId="formRoleName">
                <Form.Label className="form-label">First name</Form.Label>
                <Form.Control
                    placeholder="Firstname"
                    value={data?.name}
                    required
                    id="age"
                    // onChange={(e) => setSummary(e.target.value)}
                />
                <div className='note-text' style={{marginTop: 5}}>
                    This data comes from OLA and can’t be edited.
                </div>
            </Form.Group>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label">Surname </Form.Label>
                <Form.Control
                    placeholder="Surname"
                    value={data?.surname}
                    // value={moreInfo}
                    required
                    // onChange={(e) => setMoreInfo(e.target.value)}
                />
                <div className='note-text' style={{marginTop: 5}}>
                    This data comes from OLA and can’t be edited.
                </div>
            </Form.Group>
            <Form.Group controlId="formRoleName">
                <Form.Label className="form-label">Email </Form.Label>
                <Form.Control
                    placeholder="Email"
                    value={data?.email}
                    // value={moreInfo}
                    required
                    // onChange={(e) => setMoreInfo(e.target.value)}
                />
                <div className='note-text' style={{marginTop: 5}}>
                    This data comes from OLA and can’t be edited.
                </div>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formRoleName">
                <Form.Label className="form-label">What best describes your gender?</Form.Label>
                <Form
                    onSubmit={(e) => console.log("handle submit")}
                    style={{fontSize: 16, textAlign: "left" }}
                    onChange={handleChange}
                >
                <Form.Check // prettier-ignore
                    value={"Female"}
                    type={"radio"}
                    id={`gender-1`}
                    label={`Female`}
                    name="group1"
                    checked={data?.gender === 'Female'}
                />
                <Form.Check // prettier-ignore
                    value={"Male"}
                    type={"radio"}
                    id={`gender-2`}
                    label={`Male`}
                    name="group1"
                    checked={data?.gender === 'Male'}
                />
                <Form.Check // prettier-ignore
                    value={`Non-binary`}
                    type={"radio"}
                    id={`gender-3`}
                    label={`Non-binary`}
                    name="group1"
                    checked={data?.gender === 'Non-binary'}
                />
                <Form.Check // prettier-ignore
                    value={`Unsure how to describe myself`}
                    type={"radio"}
                    id={`gender-4`}
                    label={`Unsure how to describe myself`}
                    name="group1"
                    checked={data?.gender === 'Unsure how to describe myself'}
                />
                <Form.Check // prettier-ignore
                    value={`Prefer not to say`}
                    type={"radio"}
                    id={`gender-5`}
                    label={`Prefer not to say`}
                    name="group1"
                    checked={data?.gender === 'Prefer not to say'}
                />
                <Form.Check // prettier-ignore
                    value={"Other"}
                    type={"radio"}
                    id={`gender-6`}
                    label={`A gender not listed here`}
                    name="group1"
                    checked={data?.gender === 'Other'}
                />
                </Form>
                <Form.Control.Feedback type="invalid">
                    Please provide a title.
                </Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group className="mb-3" controlId="formRoleName">
                <Form.Label className="form-label">What is your age?</Form.Label>
                <Form.Control
                    placeholder=""
                    // value={summary}
                    required
                    id="age"
                    // onChange={(e) => setSummary(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                    Please provide a description.
                </Form.Control.Feedback>
            </Form.Group> */}
        </div>
      </div>
        <Box sx={{  mt: 10, mb: 1}}>
            <Box sx={{  mt: 2, mb: 1}}/>
            <Button style={{borderRadius: 0, marginBottom: 150}} className='normal-button' onClick={handleSubmit}>Save</Button>
        </Box>
      </>
    );
  };
  
  export default MyAccount;
  